import React, { Component, PropTypes } from 'react';
import './button.scss';
import URLService from 'service/URLService';

export default class Button extends Component {
    static propTypes = {
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onClick: PropTypes.func,
        to: PropTypes.any,
        centeredBlock: PropTypes.bool
    }

    handleClick = (ev) => {
        if(this.props.toInternal || this.props.onClick || this.props.disabled) {
            ev.preventDefault();
            ev.stopPropagation();
        }

        if(this.props.onClick) {
            this.props.onClick(ev);
        }
        if(this.props.toInternal && !this.props.disabled) {
            URLService.gotoPush(this.props.toInternal);
        }
        if(this.props.toInternal || this.props.onClick || this.props.disabled) {
            return false;
        }
    }

    render() {

        return (
            <div className={`button-wrapper ${this.props.centeredBlock ? 'button-wrapper-centered-block' : ''}`}>
                <a className={`button ${this.props.disabled ? 'button-disabled' : ''} ${this.props.className ? this.props.className : ''}`} onClick={this.handleClick} href={this.props.to || "#"}>
                    {this.props.children}
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/views/button/Button.js